import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "c-catalog" }
const _hoisted_2 = { class: "c-catalog__properties" }
const _hoisted_3 = { class: "c-catalog__grid" }

import { ref, computed } from "vue";
import CatalogFilters from "./CatalogFilters.vue";
import CatalogSorting from "./CatalogSorting.vue";
import CatalogProduct from "./product/CatalogProduct.vue";
import PaginationObject from "./objects/PaginationObject.vue";
import { getCurrentCatalog } from "../api/catalog/getCurrentCatalog";

type Props = {
	init: any;
	id: string;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'Catalog',
  props: {
    init: {},
    id: {}
  },
  setup(__props: any) {

const props = __props;

const catalog = ref(props.init);
const isLoading = ref(false);

let queryParams = new URLSearchParams(window.location.search);

// Sorting
function setSorting(sort: string) {
	if (sort) {
		setParam("sortby", sort);
	} else {
		removeParam("sortby");
	}

	fetch();
}

// Filtering
function setFilters(filters: Record<string, Number[]>) {
	for (const [key, value] of Object.entries(filters)) {
		if (value.length) {
			setParam(key, value);
		} else {
			removeParam(key);
		}
	}

	fetch();
}

// Page
function setPage(page: number) {
	if (page == 1) {
		removeParam("page");
		fetch();
		return;
	}

	setParam("page", page.toString());
	fetch();
}

// Params
function setParam(param: string, value: string | any[]) {
	queryParams.set(param, value.toString());
}

function removeParam(param: string) {
	queryParams.delete(param);
}

// Fetch
async function fetch() {
	isLoading.value = true;

	history.pushState(null, "", "?" + queryParams.toString());
	const response = await getCurrentCatalog(props.id, queryParams.toString());
	catalog.value = response.data.grid;

	isLoading.value = false;

	let element = document.getElementById("grid");
	let top = element?.offsetTop ?? 0;
	window.scrollTo({ top: top, left: 0, behavior: "smooth" });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(CatalogFilters, {
        examples: catalog.value.examples,
        filters: catalog.value.filters,
        onChanged: setFilters
      }, null, 8, ["examples", "filters"]),
      _createVNode(CatalogSorting, { onChanged: setSorting })
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(catalog.value.products, (product) => {
        return (_openBlock(), _createBlock(CatalogProduct, {
          key: product.id,
          product: product,
          loading: isLoading.value
        }, null, 8, ["product", "loading"]))
      }), 128))
    ]),
    _createVNode(PaginationObject, {
      modelValue: catalog.value.page,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((catalog.value.page) = $event)),
      "total-pages": catalog.value.pages,
      "max-visible": 4,
      onUpdated: setPage
    }, null, 8, ["modelValue", "total-pages"])
  ]))
}
}

})